import { render } from "./Asset_Categories.vue?vue&type=template&id=99b6b6b4"
import script from "./Asset_Categories.vue?vue&type=script&lang=js"
export * from "./Asset_Categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__